import React, { useMemo } from "react"

import { noop } from "shared/lib/noop"
import { useBooleanState } from "shared/lib/useBooleanState"

export interface ProjectChatContextType {
  isVisible: boolean
  hide: () => void
  show: () => void
}

export const defaultProjectChatContext: ProjectChatContextType = {
  isVisible: false,
  hide: noop,
  show: noop
}

export const ProjectChatContext = React.createContext<ProjectChatContextType>(
  defaultProjectChatContext
)

export function ProjectChatContextProvider({
  children
}: {
  children: React.ReactNode | React.ReactNode[]
}) {
  const {
    value: isVisible,
    setTrue: show,
    setFalse: hide
  } = useBooleanState(false)

  const context = useMemo<ProjectChatContextType>(
    () => ({ isVisible, show, hide }),
    [isVisible, show, hide]
  )

  return (
    <ProjectChatContext.Provider value={context}>
      {children}
    </ProjectChatContext.Provider>
  )
}
